import type { DatasetFormProps } from "./dataset-form.type";

import { DATASET_TYPE } from "@/entities/dataset";
import { DatasetCard } from "@/modules/dataset/dataset-card";

import { DatasetFormEditor } from "./dataset-form-editor";

export const DatasetForm = ({
  template,
  dataset,
  loading,
  disabled,
  datasetsImage,
  datasetsImageLoading,
}: DatasetFormProps) => {
  return (
    <DatasetCard
      datasetType={DATASET_TYPE.FORM}
      template={template}
      dataset={dataset}
      loading={loading}
      disabled={disabled}
    >
      <DatasetFormEditor
        template={template}
        dataset={dataset}
        disabled={disabled}
        datasetsImage={datasetsImage}
        datasetsImageLoading={datasetsImageLoading}
      />
    </DatasetCard>
  );
};
